import {
  AjaxBasics,
  IAjaxConfig,
  ShareLinkController,
  SystemController,
  WechatController,
} from '@mamba/clients';
import lodash from 'lodash';
import Vue from 'vue';
import { $AppConfig } from './global';
export const Store = {
  /** 推广 */
  ShareLink: new ShareLinkController(),
  /** 微信 */
  Wechat: new WechatController($AppConfig.appid),
  /** 系统 */
  System: new SystemController(),
};

AjaxBasics.merge = async function (AjaxConfig: IAjaxConfig) {
  AjaxConfig = createHeaders(AjaxConfig);
  return AjaxConfig;
};
/**
 * 创建响应头
 * @param AjaxConfig
 * @returns
 */
function createHeaders(AjaxConfig) {
  if (Store.System.AccessToken) {
    lodash.merge(AjaxConfig, {
      headers: { 'bp-token': Store.System.AccessToken },
    });
  }
  if (Store.ShareLink.promoSource) {
    lodash.merge(AjaxConfig, {
      headers: { 'x-source-website': Store.ShareLink.promoSource },
    });
  }
  // 分享码
  if (Store.ShareLink.shareCode) {
    lodash.merge(AjaxConfig, {
      headers: { 'x-bp-promo-code': Store.ShareLink.getHeaderValue() },
    });
  }
  return AjaxConfig;
}

// 全局状态
Object.defineProperty(Vue.prototype, '$Store', {
  get: lodash.constant(Store),
});
lodash.set(Vue, '$Store', Store);
// Mamba.Log.success('【 Global 】', $AppConfig, Store, Mamba);
declare module 'vue/types/vue' {
  interface VueConstructor {
    /** 全局状态 */
    $Store: typeof Store;
  }
  interface Vue {
    /** 全局状态 */
    $Store: typeof Store;
  }
}
declare module '@nuxt/types' {
  interface Context {
    /** 全局状态 */
    $Store: typeof Store;
  }
}
